import { apiClient } from './client'

export interface ProcurementTableNote {
  requestItemId: string
  procurementUserId: string
  note: string | null
}

/** Сервер принимает не больше 2000 идентификаторов за раз — шлём частями. */
const NOTES_BULK_CHUNK = 1000

/**
 * Заметки закупщиков по списку позиций.
 *
 * Запрос режется на части: в режиме «Все строки» сводная таблица грузит до
 * 10 000 позиций, а сервер принимает не больше 2000 идентификаторов. Раньше
 * такой запрос получал отказ, заметки всех закупщиков молча исчезали из
 * таблицы, и закупщик, увидев пустую ячейку, мог затереть свою заметку.
 */
export async function getProcurementNotesBulk(itemIds: string[]): Promise<ProcurementTableNote[]> {
  if (itemIds.length === 0) return []
  const chunks: string[][] = []
  for (let i = 0; i < itemIds.length; i += NOTES_BULK_CHUNK) {
    chunks.push(itemIds.slice(i, i + NOTES_BULK_CHUNK))
  }
  const parts = await Promise.all(
    chunks.map((ids) =>
      apiClient
        .post<{ success: true; data: ProcurementTableNote[] }>('/procurement-table-notes/bulk', {
          itemIds: ids,
        })
        .then((res) => res.data.data),
    ),
  )
  return parts.flat()
}

export async function saveProcurementTableNote(data: {
  requestItemId: string
  note: string
}): Promise<void> {
  await apiClient.put('/procurement-table-notes', data)
}
